export const debounce = (func: TimerHandler, ms = 400) => {
    let id = 0;
    return (...args) => {
        clearTimeout(id);
        id = setTimeout(() => func(...args), ms);
    }
}